import React, { useState } from 'react';
import LogActivityForm from '../components/LogActivityForm';
import '../styles/LogActivity.css';

const LogActivityPage = () => {
    const [showTips, setShowTips] = useState(false);

    return (
        <div className="la-page">
            <div className="la-container">
                <div className="la-header">
                    <h2>Log Activity</h2>
                </div>

                <div className="la-content">
                    <LogActivityForm />

                    <div className="la-tips-section">
                        <span
                            className="la-tips-toggle"
                            onClick={() => setShowTips(prev => !prev)}
                        >
                            💡 {showTips ? 'Hide tips' : 'Quick tips'}
                        </span>
                        {showTips && (
                            <ul className="la-tips-list">
                                <li>Answer the activity questions for how the session went overall, not its hardest moment</li>
                                <li>Check what time counts for the activity before setting your duration</li>
                                <li>Rate your Personal Effort honestly — it can add up to a 25% bonus</li>
                            </ul>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LogActivityPage;
